import { Reducer } from 'interfaces'
import { CurrenciesStatisticsReducer } from 'components/features/rewards/rewardsPane/types/store'
import { CurrenciesMetaGetMarketDataRequestAction } from 'components/features/rewards/rewardsPane/store/actions/currenciesStatistics'
import { CryptoCurrencyStatistics } from 'components/features/rewards/rewardsPane/types/cryptoCurrency'
import { CryptoRewardsCurrenciesMarketDataResponseItem } from 'components/features/rewards/rewardsPane/types/apiResponses'
import { normalize } from 'helpers/normalizeHelpers'

const INITIAL_STATE: CurrenciesStatisticsReducer = {}

export const currenciesStatisticsReducer: Reducer<CurrenciesStatisticsReducer> = (prevState = INITIAL_STATE, action) => {
  switch (action.type) {
    case CurrenciesMetaGetMarketDataRequestAction.type: {
      if (action.meta === 'request') {
        return {
          ...prevState,
          isLoading: true,
        }
      }
      if (action.meta === 'fail') {
        return {
          ...prevState,
          isLoading: false,
          error: action.payload,
        }
      }
      return {
        ...prevState,
        isLoading: false,
        currenciesStatistics: normalize(action.payload.response.map(
          (currencyMarketData: CryptoRewardsCurrenciesMarketDataResponseItem): CryptoCurrencyStatistics => ({
            id: currencyMarketData.ticker,
            marketCapUSD: currencyMarketData.market_cap,
            changePercent: parseFloat(currencyMarketData.change),
            price: currencyMarketData.price,
          })
        ), 'id'),
      }
    }

    default:
      return prevState
  }
}
